import { Injectable } from '@angular/core';
import { AppConfig } from './types/app-config.type';
import { CompanyPortalServices } from '../../modules/auth/config/appConfig';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private config: AppConfig;

    constructor() {}

    public get AnalyticsConfig() {
        return this.config.analytics;
    }

    public get isMaintenance() {
        return this.config.isMaintenance;
    }

    public get isCustomerzonePortal() {
        return this.config.portal === CompanyPortalServices.Customerzone;
    }

    public get refreshInterval() {
        return this.config.refreshInterval;
    }

    public set(appConfig: AppConfig): void {
        this.config = appConfig;
    }

    public getFeaturesConfig() {
        return this.config.features;
    }
}
